class GradientBackground {
    constructor(element) {
        this._element = element;
        this._type = null;
        this._color1 = null;
        this._color2 = null;
    }

    setType(type) {
        this._type = type;
        this._update();
    }

    setColors(color1, color2) {
        this._color1 = color1;
        this._color2 = color2;
        this._update();
    }

    _update() {
        let [type, color1, color2] = [this._type, this._color1, this._color2];

        switch (type) {
            case 'diagonal':
                this._setLinearGradient(135, color1, color2);
                break;
            case 'vertical':
                this._setLinearGradient(180, color1, color2);
                break;
            case 'horizontal':
                this._setLinearGradient(90, color1, color2);
                break;
            case 'radial':
                this._setRadialGradient(color1, color2);
                break;
        }
    }

    _setLinearGradient(angle, color1, color2) {
        this._element.style.background = `linear-gradient(${angle}deg, ${color1} 0%, ${color2} 100%)`;
    }

    _setRadialGradient(color1, color2) {
        this._element.style.background = `radial-gradient(${color2}, ${color1})`;
    }
}

export default GradientBackground;
